export default "https://cdnpdfrontuat.aikan.pdnews.cn/rmrb/es/rmrb-web-details-main/0.2.21/resource/image/channel.svg"